/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { startCase, camelCase } from 'lodash'


/**
 * @description Formats the strings
 * @param value raw values sent for formatting.
 * @returns Formatted string values 'seven_shifts' to 'Seven Shifts'
 */


export const  formatHelper = (value) => {
  if (!value || typeof value !== 'string') return '';

  return startCase(camelCase(value))
}
